import { environment } from 'environments/environment';
import { EventEmitter, Injectable } from '@angular/core';
import * as signalR from '@microsoft/signalr';

@Injectable({
  providedIn: 'root'
})
export class ScheduleHubService {
  private connection: signalR.HubConnection;
  public connectionExists: Boolean;
  public scheduleUpdateEvent = new EventEmitter<any>();

  constructor() {
    console.log('ScheduleHub Started...');
    this.connectionExists = false;

    // Создаем подключение к современному SignalR Hub
    this.connection = new signalR.HubConnectionBuilder()
      .withUrl(environment.api + 'scheduleHub', {
        transport: signalR.HttpTransportType.ServerSentEvents,
        withCredentials: false // Для CORS с credentials
      })
      .withAutomaticReconnect()
      .build();

    this.registerOnServerEvents();
  }

  public start(clubId: string) {
    this.startConnection(clubId).then();
  }

  private async startConnection(clubId: string): Promise<void> {
    if (this.connectionExists) {
      await this.connection.stop();
    }

    try {
      await this.connection.start();
      await this.connection.invoke('subscribeScheduleHub', clubId);
      this.connectionExists = true;
    } catch (error) {
      console.error('*** Could not connect ' + error);
    }
  }

  private registerOnServerEvents(): void {
    // Удаляем старые обработчики и добавляем новые
    this.connection.off('ScheduleUpdateEvent');
    this.connection.on('ScheduleUpdateEvent', (res) => this.onUpdateEvent(res));
  }

  private onUpdateEvent(res) {
    this.scheduleUpdateEvent.emit(JSON.parse(res));
  }
}
